import * as React from 'react';
import Svg, { Path, SvgProps } from 'react-native-svg';

import { designSystem } from '@/styles/styles';

const SvgComponent = (props: SvgProps) => (
    <Svg width={24} height={24} fill="none" {...props}>
        <Path
            stroke={props.fill || designSystem.colors.neutral300}
            strokeLinecap="square"
            strokeLinejoin="round"
            strokeWidth={1.75}
            d="M7 15V3m0 0L3 7m4-4 4 4m6 2v12m0 0 4-4m-4 4-4-4"
        />
    </Svg>
);
export { SvgComponent as PicksTabIcon };
